export default "__VITE_ASSET__DaEvPGse__"